import React from 'react'
import TextField from '../atoms/TextField/TextField'
const InputMail = (props) => {
    return (
        <TextField {...props} type='mail' />
    )
}

export default InputMail
